module.exports = __webpack_public_path__ + "img/gauge-simple-med.f2321220.svg";